export const oxxioMessagebarColors = {
  messagebarBackground: '{{ backgroundColors.backgroundDark }}',
  messagebarHoverBackground: '#00082e',
  messagebarText: '{{ textColors.textInverted }}',
};
